module.exports = __webpack_public_path__ + "officialStatic/img/logo19.03c6223.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo19.png
// module id = ABIz
// module chunks = 0